


import React, {useState} from 'react';
import './App.css';
import 'react-notifications/lib/notifications.css';
import Header from './component/layout/header';
import Main from './component/layout/main';
import { ThemeProvider } from '@mui/material/styles';
import theme from './themes';
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from './hooks/useAuth';
import {NotificationContainer} from 'react-notifications';

import {CacheProvider} from '@emotion/react';
import rtlPlugin from 'stylis-plugin-rtl';
import {prefixer} from 'stylis';
import createCache from '@emotion/cache';
import { Container } from '@mui/material';
import Footer from './component/layout/footer';
import { getAllDatas } from './services/material-services';
import { userEntry } from './services/user-services';
import { useEffect } from 'react';
// import { Cookies } from 'react-cookie';


const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

const cacheLtr = createCache({
    key: 'muiltr',
    stylisPlugins: [prefixer, rtlPlugin],
});


// function findArrayElementByTitle(array, country) {
//     if(array){
//         return array.find((element) => {
//             // return element.country.toLowerCase() === country.toLowerCase();
//             return element.country.toLowerCase().includes(country.toLowerCase())
//         })
//     }
//     return array
// }

function App() {
    const [dataMain, setDataMain] = useState('');

    
    // const cookies = new Cookies()
    let userStorage = localStorage.getItem('teknokey')
    if (userStorage){
        userStorage = JSON.parse(decodeURIComponent(userStorage))
    }
    let groupStorage = localStorage.getItem('tekGroup')
    if (groupStorage){
        groupStorage = JSON.parse(decodeURIComponent(groupStorage))
    }
    let langStorage = localStorage.getItem('tekLang')
    if (langStorage){
        langStorage = JSON.parse(decodeURIComponent(langStorage))
    }
    // let settingStorage = localStorage.getItem('tekSetting')
    // if (settingStorage){
    //     settingStorage = JSON.parse(decodeURIComponent(settingStorage))
    // }
    
    // const getDateCookies = () =>{
    //     const cookies = new Cookies()
    //     const ref_teken = cookies.get('ref_teken')
    //     return ref_teken
    // }

    useEffect(()=>{
        const getData = async() =>{
            await getAllDatas()
            .then(data => {
                // setDataMain(data)
                // setAuthLang(data?.data_lang)
                setDataMain(data?.data_buy_mat)
                
                // setAuthGroup(data?.data_setting)
                if(data?.data_mat_gp)
                {
                    localStorage.setItem('tekGroup', encodeURIComponent(JSON.stringify(data?.data_mat_gp)))
                }
                if(data?.data_lang)
                {
                    localStorage.setItem('tekLang', encodeURIComponent(JSON.stringify(data?.data_lang)))
                }
    
            }).catch( e => {
                // setError(true)
                // setLoding(false)
            })
        }
        getData();
        const setUserEntry = async(token, user_id) =>{
            await userEntry(token, {user:user_id})
            // .then(data =>{
            // })
        }
        if(userStorage?.token)
        {
            setUserEntry(userStorage?.token, userStorage?.user.id)
        }
    }, [userStorage])



    return (
        <>
            <CacheProvider value={langStorage?.view_sts ? cacheRtl : cacheLtr}>
                <ThemeProvider theme={theme}>
                    <AuthProvider user={userStorage} tekGroup={groupStorage} tekLang={langStorage} >
                        <div className="App">
                            <Router>
                                <Header />
                                <div className={langStorage?.view_sts ? 'general-content-right' : 'general-content-left'}>
                                    <Container fixed>
                                        <Main dataMain={dataMain}/>
                                    </Container>
                                </div>
                                <div className='footer'>
                                    <Footer />
                                </div>
                            </Router>
                        </div>
                        <NotificationContainer />
                    </AuthProvider >
                </ThemeProvider>
            </CacheProvider>
        </>
    );
}

export default App;
